import Vue from 'vue'
import Router from 'vue-router'
import { constantRouters } from '@/router/constantRouter'
import { setDocumentTitle } from '@/utils/domUtil'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouters
})

router.beforeEach((to, from, next) => {
  setDocumentTitle(to.meta.title)
  next()
})

export default router
